export default {
  nextJob: 'Nächste Charge',
  plannedJobMetricsUnavailable: 'Metriken sind verfügbar, sobald diese Charge gestartet ist.',
  previousJob: 'Vorherige Charge',
  detailsTabs: {
    consumption: 'Verbrauch',
    events: 'Ereignisse',
    images: 'Bilder',
  },
};
